'use strict';

export function dyanne_platformNavigation() {
	const primaryNav = document.querySelector('nav li.mega-submenu-default');

	if (!primaryNav) {
		return false;
	}

	const megaSubmenus = document.querySelectorAll(
		'nav li.mega-submenu-default'
	);

	megaSubmenus.forEach((item) => {
		const link = item.querySelector('a');

		link.addEventListener('click', (e) => {
			e.preventDefault();

			megaSubmenus.forEach((el) => {
				if (
					el === item &&
					el.getAttribute('aria-expanded') !== 'true'
				) {
					el.setAttribute('aria-expanded', 'true');
				} else {
					el.setAttribute('aria-expanded', 'false');
				}
			});
		});
	});
}
